// !!!!
// This is a generated file.
// Do not manually change this file
// !!!!

export const EOPENMESACTIONSTATUS = {
    To_Do: 2051604480,
    In_Processing: 2051604481,
    Done: 2051604482,
    Error: 2051604483,
    All: 2051604484,
    Wip: 2051604485,
    Hold: 2051604486,
};
